var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DrkWhite pa-4"},[_c('h2',{staticClass:"subheading green--text"},[_vm._v("Renewal Schedules")]),_c('v-card',{staticClass:"mt-4"},[_c('Renewal')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }